import React from "react";
import nikuLogo from "../../assets/images/niku-logo.png";
import CustomAlert from "../../components/alerts/customAlert";
import useLogin from "./hooks/useLogin";
import "./login.css";

const Login = () => {
  const {
    email,
    pass,
    //pending,
    isLoading,
    openError,
    errorMessage,
    onChangeEmail,
    onChangePass,
    onLogin,
    handleClose,
  } = useLogin();

  return (
    <div className="login">
      <CustomAlert
        show={openError}
        setShow={handleClose}
        title={"Error"}
        content={errorMessage}
        variantAlert={"danger"}
      />
      <div className="login-container">
        <img src={nikuLogo} alt="logo-niku" className="login-niku-logo" />
        <div className="login-form">
          <h1 className="login-title">Iniciar sesión</h1>
          <p className="login-paragraph">Gestión de ordenes</p>
          <div className="login-form-field">
            <label className="login-form-label" htmlFor="p">
              Correo
            </label>
            <input
              className="login-form-input"
              type="email"
              placeholder="correo@ejemplo.com"
              value={email}
              onChange={onChangeEmail}
            />
          </div>
          <br />
          <div className="login-form-field">
            <label className="login-form-label" htmlFor="p">
              Contraseña
            </label>
            <input
              className="login-form-input"
              type="password"
              placeholder="Ingresa tu contraseña"
              value={pass}
              onChange={onChangePass}
            />
          </div>
          <br />
          <button
            type="button"
            className="login-form-btn"
            disabled={isLoading}
            onClick={onLogin}
          >
            {isLoading ? "Cargando..." : "Iniciar sesión"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
